import algoliasearch from 'algoliasearch/lite'

export const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_ID as string
export const ALGOLIA_SEARCH_API_KEY = process.env.REACT_APP_ALGOLIA_SECRET as string
export const ALGOLIA_PRODUCT_INDEX_NAME = 'product_variants'
export const ALGOLIA_STORY_INDEX_NAME = 'Story'
export const ALGOLIA_FEED_INDEX_NAME = 'Feed'
export const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY)
export const ALGOLIA_FILTERS = 'enabled:true AND status:active'
